export default "__VITE_ASSET__Bp4jEwqX__"